// Allowing quotes, full stops and dashes for user's names e.g. O'shannasay or A.B. Somewhere, etc
// Include Latin A/B, Latin Extended Additional for cases such as naïve.
// @see https://stackoverflow.com/questions/20690499/concrete-javascript-regex-for-accented-characters-diacritics
export const LATIN_EXTENDED_REGEXP_NAMES = /[^a-zA-Z0-9&\-'".,\u00C0-\u024F\u1E00-\u1EFF\s]+/g
